<script setup lang="ts">
const _props = defineProps<{
  data: DualMediaProps
  sectionIndex: number
  template?: 'page' | 'overlay'
}>()

const container = ref<HTMLElement | null>(null)
const xIcon = ref<HTMLElement | null>(null)
</script>

<template>
  <section ref="container" class="relative flex flex-col lg:flex-row">
    <CommonMedia
      class="lg:w-1/2"
      :sizes="['70vw', '40vw']"
      :media="data.mediaLeft"
      :aspect="8 / 9"
      :loading="sectionIndex === 0 ? 'eager' : 'lazy'"
    />
    <CommonMedia
      class="lg:w-1/2"
      :sizes="['70vw', '40vw']"
      :media="data.mediaRight"
      :aspect="8 / 9"
      :loading="sectionIndex === 0 ? 'eager' : 'lazy'"
    />

    <div class="text-neon-yellow absolute inset-0 z-1 flex justify-between">
      <IconsN class="sticky top-10 -mt-px mb-auto w-1/6 translate-y-px lg:top-14" />
      <IconsX ref="xIcon" class="sticky bottom-10 mt-auto -mb-px w-1/6 lg:bottom-0" />
    </div>
  </section>
</template>
